module.exports = __webpack_public_path__ + "static/media/emares_logo_ohne_claim.ecd812e9.svg";